export enum ObjectType {
  AppInstall = "app_install",
  AppInstance = "app_instance",
  Cast = "cast",
  Channel = "channel",
  Credential = "credential",
  Favorite = "favorite",
  FeatureFlagOrg = "feature_flag_org",
  File = "file",
  Folder = "folder",
  Group = "group",
  GroupSpace = "group_space",
  Layout = "layout",
  Link = "link",
  Org = "org",
  OrgConnection = "org_connection",
  PermissionSet = "permission_set",
  Playlist = "playlist",
  Screen = "screen",
  ScreenGroup = "screen_group",
  Site = "site",
  Space = "space",
  SystemAccess = "system_access",
  Theme = "theme",
  Token = "token",
  User = "user",
  UserGroup = "user_group",
}
export const LOG_ITEMS_PER_PAGE = 15;
export const getTotalPages = (totalCount: number) =>
  Math.ceil(totalCount / LOG_ITEMS_PER_PAGE);
